<template>
  <f7-block>
    <f7-block-title>{{ $t('adminDashboard.growth') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.newUsersToday') }}</span>
        <span class="metric-val">{{ fmt(data.newUsersToday) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.newUsersThisWeek') }}</span>
        <span class="metric-val">{{ fmt(data.newUsersThisWeek) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.newUsersThisMonth') }}</span>
        <span class="metric-val">{{ fmt(data.newUsersThisMonth) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.totalReferrals') }}</span>
        <span class="metric-val">{{ fmt(data.totalReferrals) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.rewardsDistributed') }}</span>
        <span class="metric-val">{{ fmtCfa(data.rewardsDistributed) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.userGrowthRate') }}</span>
        <span class="metric-val">{{ pct(data.userGrowthRate) }}</span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function pct(v) { return v != null ? v.toFixed(1) + '%' : '-'; }
function fmtCfa(v) { if (v == null) return '-'; const n = parseFloat(v) || 0; return n.toLocaleString('fr-FR', {maximumFractionDigits:0}) + ' FCFA'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:18px; font-weight:700; color:var(--f7-text-color,#333); }
</style>